import type { RegulatoryRates } from '../../types/regulatoryRates';

/** 일당 원천·고용 계산용 rates 스냅샷 (순수 함수 인자) */
export interface DailyWorkerRatesSnapshot {
  dailyRate: number;
  creditRate: number;
  dailyExempt: number;
  localTaxRate: number;
  eiWorker: number;
}

/** 고용·산재 추정용 rates */
export interface DayInsuranceRatesSnapshot {
  eiEmployer: number;
  eiSafetyUnder150: number;
  eiWorker: number;
  wciAverage: number;
}

export function dailyWorkerRatesFromRegulatory(rates: RegulatoryRates): DailyWorkerRatesSnapshot {
  const dw = rates.withholding?.dailyWorker;
  return {
    dailyRate: dw?.rate ?? 0.06,
    creditRate: dw?.creditRate ?? 0.55,
    dailyExempt: dw?.dailyExempt ?? 150_000,
    localTaxRate: rates.withholding?.localTaxOfWithholding ?? 0.10,
    eiWorker: rates.socialInsurance?.ei?.unemployment?.worker ?? 0.009,
  };
}

export function dayInsuranceRatesFromRegulatory(rates: RegulatoryRates): DayInsuranceRatesSnapshot {
  return {
    eiEmployer: rates.socialInsurance?.ei?.unemployment?.employer ?? 0.009,
    eiSafetyUnder150: rates.socialInsurance?.ei?.empSafety?.under150 ?? 0.0025,
    eiWorker: rates.socialInsurance?.ei?.unemployment?.worker ?? 0.009,
    wciAverage: rates.socialInsurance?.wci?.averageRate ?? 0.0147,
  };
}

export function businessIncomeWithLocalFromRegulatory(rates: RegulatoryRates): number {
  const base = rates.withholding?.businessIncome ?? 0.03;
  const local = rates.withholding?.localTaxOfWithholding ?? 0.10;
  return base * (1 + local);
}
